export default {
    data() {
        return {
            LINK_TYPE: {
                JUMP_LINK: 1,
                INTERNAL_LINK: 2,
                EXTERNAL_LINK: 3,
                PRETTY_LINK: 4,
            },
        };
    },
};
